import { motion } from 'framer-motion';
import { LoadingSpinner } from './LoadingSpinner';

export function LoadingScreen() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
    >
      <div className="text-center">
        <LoadingSpinner size="large" className="mb-4" />
        <p className="text-gray-600">Loading...</p>
      </div>
    </motion.div>
  );
}
